<template>
  <div class="w-[700px] px-5 flex flex-col gap-4 pb-5">

    <div class="rounded bg-trader-dark-gray p-5 flex flex-col gap-4">
    <input type="file" @change="onFileChange"/>

    <button class="bg-trader-green text-trader-dark-green p-2" @click="uploadFile">Datei hochladen</button>
    </div>


    <table class="w-full">
      <tr>
        <td class="w-1/3">
          Eindeutige ID:
        </td>
        <td class="w-2/3">
          <input class="border w-full" v-model="uniqueId"/>
        </td>
      </tr>
      <tr>
        <td class="w-1/3">
          Vorschau Grafik:
        </td>
        <td class="w-2/3">
          <input class="border w-full" v-model="previewFilePath"/>
        </td>
      </tr>
      <tr>
        <td>
          Original Bild Pfad für den Export:
          (/volumes/...)
        </td>
        <td>
          <input class="border w-full" v-model="originalFilePath"/>
        </td>
      </tr>
    </table>


    <!--
    <div v-if="uploadResult">
      <h3>Upload Ergebnis</h3>
      <ul>
        <li v-for="(item, index) in uploadResult" :key="index">{{ item }}</li>
      </ul>
    </div>
    -->

    <div class="flex w-full gap-5">
      <button class="flex-grow bg-trader-green text-trader-dark-green p-2" @click="apply">Übernehmen</button>
      <button class="flex-grow bg-trader-green text-trader-dark-green p-2" @click="close">Abbrechen</button>
    </div>


  </div>
</template>

<script>
import axios from 'axios';
import {eventBus} from "@/application/EventBus";

export default {
  props: {
    setData: {
      type: String,
      default: ''
    },
    onApply: {
      type: Function,
      default: (value) => {}
    },
  },
  data() {
    let value = {};
    try {
      value = JSON.parse(this.setData);
    } catch (e) {}

    return {
      selectedFile: null,
      uniqueId: value?.uniqueId || '',
      previewFilePath: value?.previewFilePath || '',
      originalFilePath: value?.originalFilePath || '',
    };
  },
  methods: {
    close() {
      eventBus.closeModal();
    },
    apply() {
      try {
        const save = JSON.stringify({
          uniqueId: this.uniqueId,
          previewFilePath: this.previewFilePath,
          originalFilePath: this.originalFilePath,
        });

        this.onApply(save);
        eventBus.closeModal();
      } catch (e) {}
    },
    onFileChange(event) {
      this.selectedFile = event.target.files[0];
    },
    async uploadFile() {
      if (!this.selectedFile) {
        alert('Bitte wählen Sie eine Datei aus.');
        return;
      }

      const formData = new FormData();
      formData.append('file', this.selectedFile);

      try {
        const response = await axios.post('/api/v3/upload', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
        if(response.data.length > 0) {
          this.previewFilePath = response.data[0];
        }

      } catch (error) {
        console.error('Fehler beim Hochladen der Datei:', error);
        alert('Fehler beim Hochladen der Datei.');
      }
    },
  },
};
</script>

<style scoped>
/* Füge hier deine Stile hinzu */
</style>
